import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { MultiSelect } from 'primereact/multiselect'
import { InputTextarea } from 'primereact/inputtextarea'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import NavBar from '../../componentes/Navbar'
import { AuthContext } from '../../main/ProvedorAutenticacao'
import TriagemPublicacaoService from '../../app/service/TriagemPublicacaoService'
import UsuarioService from '../../app/service/UsuarioService'

// Atividades criadas para o usuário de triagem quando a publicação não corresponde a nenhum termo.
// O usuário de triagem abre cada uma e designa os responsáveis (e interessados); ele sai da atividade.
class PrazosSemResponsavel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openSpinner: false,
      prazos: [],
      usuarios: [],
      //Designação
      modalDesignar: false,
      prazo: null,
      responsaveis: [],
      interessados: [],
      designando: false
    }

    this.triagemPublicacaoService = new TriagemPublicacaoService();
    this.usuarioService = new UsuarioService();

    this.acoesPrazo = this.acoesPrazo.bind(this);
  }

  async componentDidMount() {
    this.setState({ openSpinner: true });
    await this.consultarPrazos();
    await this.consultarUsuarios();
    this.setState({ openSpinner: false });
  }

  consultarPrazos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.triagemPublicacaoService.listarPendentes(usuarioLogado.codigo)
      .then(response => {
        this.setState({ prazos: response.data });
      }).catch(error => {
        this.toast.show({ severity: 'error', summary: 'Prazos sem Responsável', detail: `Erro ao consultar prazos: ${error}`, life: 4000 });
      })
  }

  consultarUsuarios = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.usuarioService.listarUsuariosEmpresa(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({ usuarios: response.data.filter(u => u.situacao === 0) });
      }).catch(error => {
        this.toast.show({ severity: 'error', summary: 'Prazos sem Responsável', detail: `Erro ao consultar usuários: ${error}`, life: 4000 });
      })
  }

  abrirPrazo = async (prazoConsulta) => {
    await this.triagemPublicacaoService.consultar(prazoConsulta.codigo)
      .then(response => {
        this.setState({ modalDesignar: true, prazo: response.data, responsaveis: [], interessados: [] });
      }).catch(error => {
        this.toast.show({ severity: 'error', summary: 'Prazos sem Responsável', detail: `Erro ao abrir o prazo: ${error}`, life: 4000 });
      })
  }

  designar = async () => {
    if (this.state.responsaveis == null || this.state.responsaveis.length === 0) {
      this.toast.show({ severity: 'error', summary: 'Prazos sem Responsável', detail: 'Informe ao menos um responsável', life: 4000 });
      return;
    }
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({ designando: true });
    await this.triagemPublicacaoService.designar(this.state.prazo.codigo, {
      usuarioId: usuarioLogado.codigo,
      responsaveis: this.state.responsaveis,
      interessados: this.state.interessados
    }).then(() => {
      this.toast.show({ severity: 'success', summary: 'Prazos sem Responsável', detail: 'Atividade designada com sucesso', life: 4000 });
      this.setState({ modalDesignar: false, prazo: null });
      this.consultarPrazos();
    }).catch(error => {
      const detalhe = error.response && error.response.data && error.response.data.userMessage
        ? error.response.data.userMessage : `${error}`;
      this.toast.show({ severity: 'error', summary: 'Prazos sem Responsável', detail: `Falha ao designar: ${detalhe}`, life: 5000 });
    }).finally(() => {
      this.setState({ designando: false });
    })
  }

  acoesPrazo(rowData) {
    return (
      <Button icon="pi pi-user-plus" className="p-button-rounded p-button-text"
              tooltip="Abrir e designar responsável"
              tooltipOptions={{ position: 'top' }}
              onClick={() => this.abrirPrazo(rowData)} />
    );
  }

  prioridade(rowData) {
    return (
      <>
        {rowData.urgente === 'S' && <span style={{ color: 'red', fontWeight: 'bold' }}>Urgente </span>}
        {rowData.importante === 'S' && <span style={{ color: '#FFA726', fontWeight: 'bold' }}>Importante</span>}
      </>
    );
  }

  descricaoResumida(rowData) {
    const descricao = rowData.descricao || '';
    const resumo = descricao.length > 140 ? `${descricao.substring(0, 140)}…` : descricao;
    return <span title={descricao}>{resumo}</span>;
  }

  render() {
    const prazo = this.state.prazo;
    return (
      <>
        <NavBar />
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{ width: '130px', height: '130px' }} />
        </Backdrop>
        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fa fa-user-clock"></i>
                    <span> Prazos sem Responsável</span>
                  </h3>
                </div>
                <div className="card-body">
                  <small className="p-d-block" style={{ marginBottom: '8px' }}>
                    Publicações que não corresponderam a nenhum termo. Abra cada uma e designe o responsável.
                  </small>
                  <DataTable value={this.state.prazos}
                             emptyMessage="Nenhum prazo sem responsável"
                             size="small"
                             paginator rows={20}
                             showGridlines>
                    <Column field="nrCnj" header="Processo"></Column>
                    <Column field="titulo" header="Atividade"></Column>
                    <Column field="tribunal" header="Tribunal"></Column>
                    <Column field="dataPublicacao" header="Publicação"></Column>
                    <Column field="dtFatal" header="Prazo Fatal"></Column>
                    <Column field="dtLimite" header="Data Limite"></Column>
                    <Column header="Prioridade" body={this.prioridade}></Column>
                    <Column field="descricao" header="Providência (IA)" body={this.descricaoResumida}></Column>
                    <Column body={this.acoesPrazo} header="Ações" style={{ width: '6rem' }}></Column>
                  </DataTable>
                </div>
              </div>
            </section>
          </div>
        </div>

        <Dialog header="Designar responsável"
                visible={this.state.modalDesignar}
                style={{ width: '60vw' }}
                footer={
                  <div>
                    <Button label={this.state.designando ? 'Designando...' : 'Designar'}
                            icon="pi pi-check"
                            disabled={this.state.designando}
                            className="p-button-success p-button-text"
                            onClick={this.designar} />
                    <Button label="Fechar"
                            className="p-button-secondary p-button-text"
                            onClick={() => this.setState({ modalDesignar: false })} />
                  </div>
                }
                onHide={() => this.setState({ modalDesignar: false })}>
          {prazo && (
            <>
              <div className="row">
                <div className="col-md-12">
                  <p style={{ marginBottom: '4px' }}>
                    <strong>Processo:</strong> {prazo.nrCnj} &nbsp; <strong>Tribunal:</strong> {prazo.tribunal}
                    &nbsp; <strong>Publicação:</strong> {prazo.dataPublicacao}
                  </p>
                  <p style={{ marginBottom: '4px' }}>
                    <strong>Prazo fatal:</strong> {prazo.dtFatal} &nbsp; <strong>Data limite:</strong> {prazo.dtLimite}
                    {prazo.motivo === 'IA_INDISPONIVEL' && <span style={{ color: 'red' }}> &nbsp; (publicação não analisada pela IA)</span>}
                    {prazo.motivo === 'SEM_RESPONSAVEL' && <span style={{ color: 'red' }}> &nbsp; (o termo não definiu o responsável)</span>}
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Análise da IA</label>
                    <InputTextarea style={{ width: '100%' }} rows={5} autoResize readOnly value={prazo.descricao || ''}
                                   className="p-inputtext-sm p-d-block" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Texto da publicação</label>
                    <InputTextarea style={{ width: '100%', maxHeight: '260px', overflowY: 'auto' }} rows={8} readOnly
                                   value={prazo.publicacao || ''} className="p-inputtext-sm p-d-block" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Responsáveis *</label>
                    <MultiSelect value={this.state.responsaveis}
                                 options={this.state.usuarios}
                                 optionLabel="nome"
                                 optionValue="codigo"
                                 filter
                                 display="chip"
                                 placeholder="Selecione os responsáveis"
                                 onChange={e => this.setState({ responsaveis: e.value })}
                                 style={{ width: '100%' }} />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Interessados</label>
                    <MultiSelect value={this.state.interessados}
                                 options={this.state.usuarios}
                                 optionLabel="nome"
                                 optionValue="codigo"
                                 filter
                                 display="chip"
                                 placeholder="Opcional"
                                 onChange={e => this.setState({ interessados: e.value })}
                                 style={{ width: '100%' }} />
                  </div>
                </div>
              </div>
            </>
          )}
        </Dialog>
      </>
    );
  }
}
PrazosSemResponsavel.contextType = AuthContext;
export default withRouter(PrazosSemResponsavel)
